import ConfigCharts from '@/language/es/components/config/ConfigCharts';
import ConfigContract from '@/language/es/components/config/ConfigContract';
import ConfigModal from '@/language/es/components/config/ConfigModal';
import ConfigStyle from '@/language/es/components/config/ConfigStyle';
import ConfigUsers from '@/language/es/components/config/ConfigUsers';
import IntegrationToken from '@/language/es/components/config/IntegrationToken';

export default {
  ConfigCharts,
  ConfigContract,
  ConfigModal,
  ConfigStyle,
  ConfigUsers,
  IntegrationToken,
};
